import { APIRuntimeBuilder } from '@cian/mf-registry/browser';
import { dispatchSearchClickEvent, ESearchType, SEARCH_CLICK_EVENT } from 'browser/utils';
import { setJsonQuery } from 'shared/actions/filterJsonQuery';
import { TReduxStore, TThunkDispatch } from 'shared/types/redux';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/set-filter-json-query',
      handler: async (data: { jsonQuery: object }) => {
        return (store.dispatch as TThunkDispatch)(setJsonQuery(data.jsonQuery));
      },
    },
    {
      path: '/v1/click-search-suggestion',
      handler: async (data: { type: ESearchType }) => {
        dispatchSearchClickEvent({ type: data.type });

        return {
          success: true,
          dispatchedEvent: SEARCH_CLICK_EVENT,
          eventDetail: { type: data.type },
        };
      },
    },
  ];
}
